import { useV2ListProjectPhasesForAccountQuery } from "@generated";

export const useProjectPhases = (projectId: string) => {
  const { data, isLoading } = useV2ListProjectPhasesForAccountQuery({
    filter: { project: Number(projectId) },
  } as any);
  const phases = (data?.data ?? []).map((p: any) => ({
    id: String(p.id),
    name: p.attributes?.name ?? "",
  }));
  return { phases, isLoading };
};
